module.exports = __webpack_public_path__ + "static/media/logo-12@2x.ad9b02d3.png";